<template>
  <div v-if="info!=null"
       style="height:100%">
    <div class="pbody"
         v-if="!isMobile()"
         :style="'background-image: url(' + info.backgroundImageUrl + ')'">
      <div :class="info.introduce?'pbox':'pbox2'">
        <div class="ptop">
          <el-form label-width="80px"
                   class="form"
                   :model="form">
            <el-form-item label="姓名">
              <el-input v-model="form.name"
                        placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="证书编号">
              <el-input v-model="form.code"
                        placeholder="请输入证书编号"></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <el-radio-group v-model="form.sex">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         style="width:370px"
                         @click="onSubmit">查询</el-button>
            </el-form-item>
          </el-form>
          <div class="pjianjie"
               v-html="info.introduce"></div>
        </div>
        <h4 class="pbottitle"
            v-if="isZs">证书信息</h4>
        <div class="pbot"
             v-if="isZs">
          <div class="pbbox"
               :style="index==0?'':'border-left:1px solid #000'"
               v-for="(item,index) in zsInfo"
               :key="index">
            <div class="pbbtop">{{item.fieldCNName}}</div>
            <div class="pbbbot">{{item.fieldValues}}</div>
          </div>
        </div>
        <div class="pfot"
             v-if="isZs">
          <el-button type="primary"
                     @click="isZs=false">确认</el-button>
        </div>
      </div>
    </div>
    <div class="mbody"
         v-else
         :style="'background-image: url(' + info.h5BackgroundImageUrl + ')'">
      <div class="mbox">
        <van-form @submit="onSubmit"
                  label-width="5em">
          <van-field v-model="form.name"
                     label="姓名"
                     placeholder="请输入姓名" />
          <van-field v-model="form.code"
                     label="证书编号"
                     placeholder="请输入证书编号" />
          <van-field label="性别">
            <template #input>
              <van-radio-group v-model="form.sex"
                               direction="horizontal">
                <van-radio :name="1">男</van-radio>
                <van-radio :name="2">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-button round
                      style="margin-top:25px"
                      block
                      type="info"
                      native-type="submit">查询</van-button>
        </van-form>
        <div class="mbot"
             v-if="isZs">
          <h4 class="pbottitle">证书信息</h4>
          <div class="pbot">
            <div class="pbbox"
                 :style="index==0?'':'border-left:1px solid #000'"
                 v-for="(item,index) in zsInfo"
                 :key="index">
              <div class="pbbtop">{{item.fieldCNName}}</div>
              <div class="pbbbot">{{item.fieldValues}}</div>
            </div>
          </div>
          <div class="pfot">
            <van-button type="info"
                        @click="isZs=false"
                        size="small">确认</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { Dialog } from 'vant';
export default {
  data () {
    return {
      id: 0,
      info: null,
      form: {
        name: '',
        code: '',
        sex: 1
      },
      isZs: false,
      zsInfo: null
    };
  },
  created () {
    if (this.$route.query.id) {
      this.id = Number(this.$route.query.id)
      this.getInfo()
    }
  },
  methods: {
    isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    getInfo () {
      this.httphelper.get('/api/TrainingProjectApi/GetTrainingProject', {
        proId: this.id
      }).then((res) => {
        if (res.code == 200) {
          this.info = res.data
          this.$h5weixinshare.WeiXinShare(res.data.name, window.location.href, res.data.shareProfile, res.data.shareImageUrl);
        }
      })
    },
    onSubmit () {
      if (this.form.name == '') return this.toTip('姓名为空')
      if (this.form.code == '') return this.toTip('证书编号为空')
      this.httphelper.get('/api/TrainingProjectApi/GetTrainingCertificate', {
        proId: this.id,
        name: this.form.name,
        certificateCode: this.form.code,
        sex: this.form.sex
      }).then((res) => {
        if (res.code == 200) {
          this.zsInfo = res.data
          this.isZs = true
        } else {
          this.zsInfo = null
          this.isZs = false
          if (this.isMobile()) {
            Dialog.alert({
              title: '系统提示',
              message: '未查询到该证书信息',
            })
          } else {
            this.$alert('未查询到该证书信息', '系统提示', {
              confirmButtonText: '确定',
              showClose: false
            });
          }
        }
      })
    },
    toTip (text) {
      if (this.isMobile()) {
        Toast.fail(text);
      } else {
        this.$message({
          message: text,
          type: 'warning'
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pbody {
    height: 100%;
    background: no-repeat top center;
    background-size: auto 100%;
    overflow: hidden;
    .pbox {
        width: 1000px;
        padding: 60px 30px;
        border-radius: 20px;
        margin: 35vh auto;
        background-color: rgba(255, 255, 255, 0.9);
        display: flex;
        flex-direction: column;
        .ptop {
            display: flex;
            height: 230px;
            .form {
                width: 450px;
                margin-right: 50px;
                padding-right: 50px;
                border-right: 1px dashed rgb(197, 197, 197);
            }
            .pjianjie {
                width: 440px;
                height: 230px;
                overflow-y: auto;
            }
        }
        .pbottitle {
            margin-left: 20px;
        }
        .pbot {
            // height: 103px;
            width: calc(100% - 40px);
            display: flex;
            // justify-content: center;
            // padding-top: 30px;
            margin: 0px 20px 15px;
            box-sizing: border-box;
            overflow-y: auto;
            .pbbox {
                border-bottom: 1px solid #000;
                div {
                    padding: 0 30px;
                    border-top: 1px solid #000;
                    line-height: 35px;
                    white-space: nowrap;
                    text-align: center;
                }
            }
        }
        .pbot::-webkit-scrollbar {
            width: 10px;
            height: 10px;
            /**/
        }
        .pbot::-webkit-scrollbar-track {
            background: #ddd;
            border-radius: 6px;
        }
        .pbot::-webkit-scrollbar-thumb {
            background: #bbb;
            border-radius: 10px;
        }
        .pfot {
            display: flex;
            justify-content: center;
            margin-bottom: -15px;
            margin-top: 25px;
        }
    }
    .pbox2 {
        width: 480px;
        padding: 60px 30px;
        border-radius: 20px;
        margin: 35vh auto;
        background-color: rgba(255, 255, 255, 0.9);
        display: flex;
        flex-direction: column;

        .ptop {
            display: flex;
            height: 230px;
            .form {
                width: 450px;
                padding-right: 50px;
            }
            .pjianjie {
                display: none;
            }
        }
        .pbottitle {
            margin-left: 20px;
        }
        .pbot {
            // height: 103px;
            width: calc(100% - 50px);
            display: flex;
            // justify-content: center;
            // padding-top: 30px;
            margin: 0px 30px -10px 20px;
            box-sizing: border-box;
            overflow-y: auto;
            .pbbox {
                border-bottom: 1px solid #000;
                div {
                    padding: 0 20px;
                    border-top: 1px solid #000;
                    line-height: 35px;
                    white-space: nowrap;
                    text-align: center;
                }
            }
        }
        .pbot::-webkit-scrollbar {
            width: 10px;
            height: 10px;
            /**/
        }
        .pbot::-webkit-scrollbar-track {
            background: #ddd;
            border-radius: 6px;
        }
        .pbot::-webkit-scrollbar-thumb {
            background: #bbb;
            border-radius: 10px;
        }
        .pfot {
            margin-top: 25px;
            display: flex;
            justify-content: center;
            margin-bottom: -15px;
        }
    }
}
.pczs ::v-deep .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 5px;
}
.pczs ::v-deep .el-dialog__title {
    font-weight: 800;
}
.pzsrow {
    display: flex;
    border-bottom: 1px solid #eee;
    height: 38px;
    align-items: center;
    .pzslabel {
        width: 4em;
        text-align: justify;
        text-justify: distribute-all-lines;
        text-align-last: justify;
    }
}
.pzsbot {
    ::v-deep .el-button {
        background-color: #0b8586 !important;
        border-color: #0b8586 !important;
    }
}
.mbody {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    overflow: hidden;
    .mbox {
        width: 90vw;
        margin: 35vh 5vw 0;
        .mbot {
            background-color: #fff;
            padding: 5px 0 20px;
            margin-top: 20px;
        }
        .pbottitle {
            // margin-left: 15px;
            margin: 10px 15px;
            font-size: 15px;
        }
        .pbot {
            width: calc(100% - 30px);
            display: flex;
            margin: 0px 15px;
            box-sizing: border-box;
            overflow-y: auto;
            .pbbox {
                border-bottom: 1px solid #000;
                div {
                    padding: 0 15px;
                    font-size: 14px;
                    border-top: 1px solid #000;
                    line-height: 32px;
                    white-space: nowrap;
                    text-align: center;
                }
            }
        }
        .pbot::-webkit-scrollbar {
            width: 10px;
            height: 10px;
            /**/
        }
        .pbot::-webkit-scrollbar-track {
            background: #ddd;
            border-radius: 6px;
        }
        .pbot::-webkit-scrollbar-thumb {
            background: #bbb;
            border-radius: 10px;
        }
        .pfot {
            display: flex;
            justify-content: center;
            margin-top: 10px;
            margin-bottom: -5px;
        }
    }
}
</style>